module.exports = __webpack_public_path__ + "img/githubLogo.3ba203d6.svg";